import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded',function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = function() {   
        
        gsap.utils.toArray(".js-fadeInChildren > *").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-50px bottom',
                    toggleActions: "play complete complete reset",
                },
                opacity: 0, 
                duration: 1,
                y: 50
            });
        });
        
        const meet = function() {
            ScrollTrigger.batch(".c-meet__avatars .o-cols .o-cols__item", {
                start: '0 bottom',
                onEnter: elements => {
                    gsap.from(elements, {
                        opacity: 0,
                        y: 60,
                        stagger: 0.15,
                    });
                },
                once: false
            });
        };
        
        const steps = function() {
            
            const sections = gsap.utils.toArray(".c-steps .o-cols");
            
            sections.forEach( section => {
                gsap.from(section.querySelectorAll(".o-cols__item"), {
                    opacity: 0,
                    x: 50,
                    duration: 1,
                    stagger: 0.5,
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom-=200",
                    }
                });
            });
            
            const dots_sections = gsap.utils.toArray(".c-steps .dots-section");

            dots_sections.forEach( section => {
                gsap.from(section.querySelectorAll(".dots"), {
                    opacity: 0,
                    duration: 2,
                    stagger: 0.5,
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom-=200",
                        once: true
                    }
                });
            });
        };

        document.getElementsByClassName('c-meet__avatars')[0] ? meet() : false;
        document.getElementsByClassName('c-steps')[0] ? steps() : false;
    };

}, false)
